import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Confluence Premium Popup (Confluence in trial or predunning).
 */
export function isEligibleForConfluencePremiumPopup(context: EditionAwarenessContextType): boolean {
	const { product, edition, isInTrial, isInPredunning, isInCollection } = context;

	if (fg('ea_audience_and_timing_refactor')) {
		return Boolean(
			!isInCollection &&
			isEditionOneOf(edition, ['premium']) &&
			product === 'confluence' &&
			(isInTrial || isInPredunning),
		);
	}

	return Boolean(
		isEditionOneOf(edition, ['premium']) &&
		product === 'confluence' &&
		(isInTrial || isInPredunning),
	);
}
